<template>
  <!-- 财务管理 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">煤矿流水</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label>
          <el-select v-model="filterForm.coalMineNo" clearable filterable placeholder="请选择煤矿">
            <el-option
              v-for="item in allCoalmineList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.purchaseNo" clearable filterable placeholder="请选择采购方名称">
            <el-option
              v-for="item in purchaserList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.tradeType" clearable placeholder="请选择变化类型">
            <el-option
              v-for="item in tradeTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.createUser" clearable filterable placeholder="请选择操作员">
            <el-option
              v-for="item in createUserList"
              :key="item.staffId"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.createTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-sign-out"
            label="导出"
            v-loading.fullscreen.lock="fullscreenLoading"
            perms="30900"
            type="primary"
            @click="handleExport"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      v-loading="loading"
      :data="financeList"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="flowNo"
    >
      <el-table-column type="index" width="50" align="center" fixed label="序号"></el-table-column>
      <el-table-column prop="flowNo" align="center" width="200" label="编号"></el-table-column>
      <el-table-column prop="coalMineName" align="center" width="120" label="煤矿"></el-table-column>
      <el-table-column prop="purchaseName" align="center" width="120" label="采购方"></el-table-column>
      <el-table-column prop="createTime" align="center" width="150" label="时间"></el-table-column>
      <el-table-column prop="waybillNo" align="center" width="180" label="运单编号"></el-table-column>
      <el-table-column prop="bookingNo" align="center" width="180" label="预约号"></el-table-column>
      <el-table-column prop="tradeAmount" align="center" width="120" label="金额变化（元）"></el-table-column>
      <el-table-column prop="tradeTypeDesc" align="center" width="120" label="变化类型"></el-table-column>
      <el-table-column prop="remainingAmount" align="center" width="120" label="账户余额（元）"></el-table-column>
      <el-table-column prop="createUser" align="center" width="120" label="操作人"></el-table-column>
      <el-table-column prop="paymentVoucher" align="center" width="120" label="付款凭证">
        <template slot-scope="scope">
          <el-image
            class="voucher"
            v-if="scope.row.paymentVoucher"
            :src="scope.row.paymentVoucher"
            :preview-src-list="[scope.row.paymentVoucher]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="remark" align="center" label="备注">
        <template slot-scope="scope">
          <span>{{scope.row.remark || '无'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

let that = null;
export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      fullscreenLoading: false,
      tradeTypeList: [],
      purchaserList: [],
      createUserList: [],
      allCoalmineList: [],
      financeList: [],
      filterForm: {
        coalMineNo: "",
        purchaseNo: "",
        tradeType: "",
        createUser: "",
        createTime: ""
      }
    };
  },
  created() {
    that = this;
  },
  mounted() {
    this.getPurchaseAccountList();
    this.getTradeType();
    this.getPetPurchaserList();
    this.getCreateUserList();
    this.getAllCoalmineList();
  },
  methods: {
    // 获取财务列表
    async getPurchaseAccountList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.finance.getPurchaseAccountList(params);
      const data = res.data;
      this.totalSize = data.totalSize || 0;
      if (data && data.dtoList && data.dtoList.length > 0) {
        this.financeList = data.dtoList;
      } else {
        this.financeList = [];
      }
      this.loading = false;
    },
    getTradeType() {
      this.$api.finance.getTradeType().then(res => {
        if (res.data && res.data.length > 0) {
          this.tradeTypeList = res.data;
        } else {
          this.tradeTypeList = [];
        }
      });
    },
    // 获取采购方列表
    async getPetPurchaserList() {
      let res = await this.$api.purchaser.mGetEjyAllPurchaseList()
      if (res.data && res.data.length > 0) {
        this.purchaserList = res.data.filter(item => item.name)
      } else {
        this.purchaserList = [];
      }
    },
    // 根据煤矿编号查询人员
    getCreateUserList() {
      this.$api.system.mSelectCoalMineNoStaff().then(res => {
        if (res.data && res.data.length > 0) {
          this.createUserList = res.data;
        } else {
          this.createUserList = [];
        }
      });
    },
    // 获取所有煤矿
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then(res => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getPurchaseAccountList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getPurchaseAccountList();
    },
    // 重置
    handleReset() {
      this.filterForm = {
        coalMineNo: "",
        purchaseNo: "",
        tradeType: "",
        createUser: "",
        createTime: ""
      };
      this.handleSearch();
    },
    // 导出
    handleExport() {
      this.fullscreenLoading = true;
      const params = {
        pageNo: 1,
        pageSize: 10000
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      this.$api.finance.mExport(params).then(res => {
        const data = res.data;
        if (data && data.dtoList && data.dtoList.length > 0) {
          const list = this.exportFormat(data.dtoList);
          this.exportExcel(list);
          this.fullscreenLoading = false;
        } else {
          this.$message({ message: "暂无数据" });
          this.fullscreenLoading = false;
        }
      });
    },
    exportExcel(list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../utils/Export2Excel");
        const tHeader = [
          "序号",
          "编号",
          "煤矿",
          "采购方",
          "时间",
          "运单编号",
          "预约号",
          "金额变化（元）",
          "变化类型",
          "账户余额（元）",
          "操作人",
          "付款凭证",
          "备注"
        ]; // 设置Excel的表格第一行的标题
        const filterVal = [
          "index",
          "flowNo",
          "coalMineName",
          "purchaseName",
          "createTime",
          "waybillNo",
          "bookingNo",
          "tradeAmount",
          "tradeTypeDesc",
          "remainingAmount",
          "createUser",
          "paymentVoucher",
          "remark"
        ]; // index、nickName、name是tableData里对象的属性
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "煤矿流水"); //导出Excel 文件名
      });
    },
    // 导出时类型转化
    exportFormat(res) {
      const list = res;
      list.forEach((item, index) => {
        item["index"] = index + 1;
        item["remark"] = item["remark"] || "无";
      });
      return list;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style lang="scss" scoped>
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #8c939d;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.voucher {
  width: auto;
  height: 50px;

  ::v-deep .el-image__inner {
    width: auto;
    height: 50px;
  }
}
</style>
